module.exports = __webpack_public_path__ + "static/media/logo.281ab93d.png";